module.exports = __webpack_public_path__ + "img/lighthouse_1.bae549ee.webp";